/**
 * Returns a 32-character lowercase hex string.
 * Matches SIP backend's `randomBytes(16).toString('hex')`
 * so the same id can be used as `x-request-id` across PBX and SIP.
 */
export function generateRequestId(): string {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
